import React from "react"
import PropTypes from "prop-types"

import css from "./AnimateTag.scss"

const TAG_SIZES = {
    sm: "small",
    md: "medium",
}

const Tag = ({ text, size, animate }) => {
    return (
        <div className={`${css.tag} ${css[TAG_SIZES[size]]} ${animate ? "" : css.stopAnimation}`}>{text}</div>
    )
}

Tag.propTypes = {
    text: PropTypes.string.isRequired,
    size: PropTypes.oneOf(["sm", "md"]),
    animate: PropTypes.bool,
}

Tag.defaultProps = {
    size: "sm",
    animate: false,
}

export default Tag
